import { useEffect, type ReactNode } from 'react';
import { useAuthStore } from '../store/authStore';

const WEB_APP_LOGIN_URL =
  import.meta.env.VITE_WEB_APP_URL
    ? `${import.meta.env.VITE_WEB_APP_URL}/login`
    : 'http://localhost:5173/login';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const returnUrl = encodeURIComponent(window.location.href);
      window.location.href = `${WEB_APP_LOGIN_URL}?returnTo=${returnUrl}`;
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return (
      <div className="page-loader">
        <div className="spinner spinner--lg" />
        <p className="page-loader__text">Verifying authentication...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="page-loader">
        <div className="spinner spinner--lg" />
        <p className="page-loader__text">Redirecting to login...</p>
      </div>
    );
  }

  return <>{children}</>;
}
